/* eslint-disable no-unused-vars */
export default class ChatStrategy {
  getInitialMessage() {
    return null;
  }

  shouldAutoSubmit() {
    return true;
  }

  getStrategyTitle() {
    throw new Error('getStrategyTitle must be implemented');
  }

  createPayload(chatId, currentJob, interactions, metadata) {
    throw new Error('createPayload must be implemented');
  }

  parseUserMessage(message) {
    throw new Error('parseUserMessage must be implemented');
  }

  onMessageReceived(event) {
    throw new Error('onMessageReceived must be implemented');
  }

  getIdentity(metadata) {
    throw new Error('getIdentity must be implemented');
  }
}
